import React, { useEffect, useState } from "react";
import '../../../CSS/TablaHerramientas.css'
import {BsPlus} from "react-icons/bs";
import axios from 'axios';
import {URI, getPermission} from '../../../Conexiones/Conexion'
import { useNavigate } from "react-router";
import moment from "moment/moment";
import { IoArrowUndo } from "react-icons/io5";
import ModalEntrada from "./ModalEntrada";
import { getToken } from "../../../Conexiones/Conexion";

function EntradaHerramientas(){
    sessionStorage.removeItem("idCH")
    sessionStorage.removeItem("nomCH")
    const navigate = useNavigate()
    const [entradaHerramientas, setEntradaHerramientas] = useState([])
    const [tablaHer, setTablaHer] = useState([])
    const [busqueda, setBusqueda] = useState("")
    const usuario = JSON.parse(sessionStorage.getItem('user')) 
    const idUsuario = usuario[0].idUsuario

    useEffect( ()=>{
        const getHerramientas = async () =>{
            const permiso = await getPermission(idUsuario,25);
            if(permiso){
                const obraId = parseInt(sessionStorage.getItem("obra"))
                const res = await axios.get(URI + 'entradaherramientas/'+obraId,{
                    headers: {
                        'Authorization': `Bearer ${getToken()}`
                    },
                    }).catch(
                        err =>{
                            if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                                navigate('/')
                            }
                        }
                    )
                setEntradaHerramientas(res.data)
                setTablaHer(res.data)
            }else{
                navigate('/inicio')
            }

        }
        getHerramientas()
    })

    const [obra,setObra] = useState('')
    
    useEffect(() => {
        const getObras = async () => {
            const obraId = parseInt(sessionStorage.getItem("obra"))
            const res = await axios.get(URI+'obras/'+obraId,{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                }).catch(
                    err =>{
                        if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                            navigate('/')
                        }
                    }
                )
            setObra(res.data.nombreObra);
          };
        getObras();
    }, [navigate]);
   
    const buscar = e => {
        setBusqueda(e.target.value)
        filtrar(e.target.value)
    }

    const filtrar = (texto) => {
        var resBusqueda = tablaHer.filter((elemento)=> {
            if  (elemento.nombreHer.toString().toLowerCase().includes(texto.toLowerCase())){  
                return elemento; }
                return resBusqueda
            })
        setEntradaHerramientas(resBusqueda)
    }
    const regresar = () => {
        navigate('/inicio/Proyectos/Lista-Obras/Administracion-Obras/Herramientas/')
    }
    
    return(
        <div className="tablaHerramientas">            
            <div >
                <h3 className="text-uppercase tituloGastos">ENTRADA DE HERRAMIENTAS DE OBRA</h3>
                <IoArrowUndo title="REGRESAR" onClick={regresar} style={{position:'absolute', right:'40px', top:'60px', fontSize:'40px', cursor:'pointer', color:'#1A2E4F'}}/>
            </div>
            <div>
                <h4 className='text-uppercase'>{obra}</h4>
            </div>
            <ModalEntrada />
            <div className='divboton' >                                                                                             
                <div className='boton' style={{display:'flex', justifyContent:'space-between'}} >
                    <button  className="btn btncolor" data-bs-toggle="modal" data-bs-target="#modal-entrada">
                        <label className="agregar">HERRAMIENTA</label><BsPlus style={{fontSize:'25px'}}/>
                    </button>
                    <input className="form-control" value={busqueda} onChange={buscar} style={{width:'50%'}} type="search" placeholder="Buscar" aria-label="Search"/>                    
                </div>
            </div>
            {
                entradaHerramientas.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                    <div className="tabla-cajaH" >
                        <div className="table tabla">
                            <table className="table table-hover table-bordered text-uppercase">
                                <thead className="encabezado">
                                    <tr >
                                        <th>CODIGO</th>                                
                                        <th>HERRAMIENTA</th>
                                        <th>RECIBE</th>
                                        <th>ENTREGA</th>
                                        <th>HORA</th>
                                        <th>FECHA</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {entradaHerramientas.map(entrada =>{
                                        return(
                                            <tr key={entrada.idEntHer}>
                                                <td>{entrada.codigoHer}</td>
                                                <td>{entrada.nombreHer}</td>
                                                <td>{entrada.recibe}</td>                                    
                                                <td>{entrada.entrega}</td>
                                                <td>{entrada.horaEntHer}</td>
                                                <td>{moment(entrada.fechaEntHer).format("DD/MM/YYYY")}</td>                                                                                       
                                            </tr>                                   
                                        )
                                    })}                        
                                </tbody>
                            </table>
                        </div>           
                    </div>
                )
            }
        </div>
    )
}

export default EntradaHerramientas;